import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendTypingActionToClientPortal } from 'services/pod';

interface IPayload {
  chatId: number;
  IsTyping: boolean;
  IsTechTyping: boolean;
}

export const ThunkSendTypingActionToClientPortal = createAsyncThunk<boolean, IPayload>(
  'clientPortalChats/sendTypingActionToClientPortal',
  async payload => {
    await sendTypingActionToClientPortal(payload.chatId, payload);
    return true;
  },
);
